import { render, staticRenderFns } from "./folder-in-list-vessel.vue?vue&type=template&id=bcea908a&scoped=true"
import script from "./folder-in-list-vessel.vue?vue&type=script&lang=js"
export * from "./folder-in-list-vessel.vue?vue&type=script&lang=js"
import style0 from "./folder-in-list-vessel.vue?vue&type=style&index=0&id=bcea908a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcea908a",
  null
  
)

export default component.exports